import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/Blog56/image1.png";
import image3 from "../../../../assets/images/Blog56/image3.png";
import image4 from "../../../../assets/images/Blog56/image4.png";
import image7 from "../../../../assets/images/Blog56/image7.png";
import image45 from "../../../../assets/images/Blog56/image45.png";
import image24 from "../../../../assets/images/Blog56/image24.png";
import image118 from "../../../../assets/images/Blog56/image118.png";
import image102 from "../../../../assets/images/Blog56/image102.png";
import image59 from "../../../../assets/images/Blog56/image59.png";
import image113 from "../../../../assets/images/Blog56/image113.png";
import image57 from "../../../../assets/images/Blog56/image57.png";
import image15 from "../../../../assets/images/Blog56/image15.png";
import image53 from "../../../../assets/images/Blog56/image53.png";
import image123 from "../../../../assets/images/Blog56/image123.png";
import image124 from "../../../../assets/images/Blog56/image124.png";
import image140 from "../../../../assets/images/Blog56/image140.png";
import image136 from "../../../../assets/images/Blog56/image136.png";
import image131 from "../../../../assets/images/Blog56/image131.png";
import image144 from "../../../../assets/images/Blog56/image144.png";
import image143 from "../../../../assets/images/Blog56/image143.png";
import image86 from "../../../../assets/images/Blog56/image86.png";

const Blog56 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – February 16, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">AI Anxiety Meets Earnings Resilience, Rotation Beneath the Surface</p>

        <p>
          Markets move into the back half of February, navigating a complex mix of strong earnings momentum and heightened uncertainty around AI-driven disruption. Price action has reflected a period
          of reassessment rather than outright deterioration, with sharp swings and leadership shifts highlighting how positioning is being recalibrated across sectors.
        </p>
        <p>
          Liquidity remains supportive, yet participation reveals signs of caution. Defensive rotations, sensitivity to macro releases, and difficulty sustaining moves at key levels point to
          underlying stress even as the broader equity structure holds together.
        </p>

        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Rotation and Repricing Without Structural Breakdown</p>

              <p>
                Equity markets have experienced notable multiple compression even as earnings continue to advance, reflecting a repricing of expectations rather than a deterioration in fundamentals.
                AI-related fears have driven broad sector anxiety, contributing to unwinds in momentum trades and increased dispersion across industries.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="AI scare trade everywhere"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Flows into defensive sectors alongside continued strength in growth expectations highlight a market balancing caution with opportunity. The environment suggests that buying high-growth
                companies at market-level multiples may present opportunities as rotations settle.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="buy growth stocks at mkt multiples"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Flows toward non-US equities continue to reverse prior concentration, supported by expectations of fiscal loosening across major economies. This shift underscores a broader
                participation dynamic rather than a narrow leadership environment.
              </p>
              <div className="relatedImg">
                <img
                  src={image4}
                  alt="ex-Us equity trade alive and well"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image4)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Japan remains a focal point as a supportive mix of policy direction, currency dynamics, and investor demand attracts both domestic and foreign capital.</p>
              <div className="relatedImg">
                <img
                  src={image7}
                  alt="Japan bid catches mkts out"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image7)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Liquidity, Inflation Signals, and Global Drivers</p>
              <p>
                Cross-asset price action reflected the interaction between softer inflation prints and evolving expectations around policy support. Inflation readings came in cooler across headline
                measures, reinforcing the view that price pressures are moderating and allowing markets to lean toward expectations of easing conditions without signalling a shift in growth
                fundamentals.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image45}
                    alt="cpi yoy"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image45)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Labour market developments showed signs of slowing momentum without deterioration, with revisions highlighting how expectations continue to adjust as the breakeven pace of job growth
                declines. Growth tracking estimates have edged lower but continue to indicate expansion, reinforcing a cooling rather than contractionary backdrop.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt="NFP revision estimates"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Rates markets responded with yields trending lower, providing a supportive anchor for risk assets even as volatility persisted across equities. The move reflects expectations of easing
                financial conditions and reinforces the role of rates as a key transmission channel for broader market sentiment.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image118}
                    alt="US10Y trending down"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image118)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Global policy dynamics remained in focus, with fiscal support expectations and ongoing capital expenditure — particularly around technology — underpinning the broader macro
                environment. International flows and policy developments, including Japan’s supportive mix of demand and currency dynamics, continued to attract attention across asset classes.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="Japan bid catches mkts ou"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Consolidation with Reactive Positioning</p>
              <p>
                Headline indices remained within broader ranges as repeated tests of key levels reflected a market consolidating after strong gains. Difficulty sustaining moves above resistance
                underscored how positioning remains tactical, with participants reacting quickly to shifts in momentum.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image102}
                    alt="QQQ struggling to hold key levels"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image102)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Leadership rotation persisted as large technology names consolidated while other areas of the market attracted flows, reinforcing a broadening dynamic beneath stable headline indices.
                Dispersion across sectors remained elevated as investors adjusted exposures.
              </p>
              <div className="relatedImg">
                <img
                  src={image59}
                  alt="MAGS 10% correction"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image59)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Sentiment indicators pointed to rising caution, with rapid swings between overbought and oversold conditions highlighting reactive positioning. Episodes where supportive developments
                failed to generate follow-through reflected fragile conviction across participants.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image113}
                    alt="Fear gauge alert"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image113)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Breadth remained constructive in parts of the market, suggesting participation beyond narrow leadership even as volatility persisted. Range-bound behaviour reinforced the importance of
                monitoring positioning shifts as markets digested prior gains.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image57}
                    alt="Breadth printing ATH counts"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image57)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Cooling Inflation and Positioning Adjustments</p>
              <p>Recent developments reinforced the theme of easing inflation alongside resilient growth, while cross-asset movements reflected ongoing repositioning rather than structural change.</p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>Inflation readings came in softer, reinforcing expectations of moderating price pressures and supportive financial conditions.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image45}
                        alt="cpi yoy"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image45)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>Seasonal dynamics and ongoing developments in China continued to influence global flows and sentiment.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image15}
                        alt="China AI headlines"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image15)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Corporate earnings remained strong, with a high proportion of companies exceeding expectations and forward estimates continuing to rise.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image53}
                        alt="SPX eps jumping25Q4"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image53)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br>Precious metals and broader commodity markets remained influenced by supply dynamics, geopolitical considerations, and positioning shifts.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image123}
                      alt="commodity breakout s/t resistance?"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image123)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image124}
                      alt="Gold is money!"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image124)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br>Digital assets experienced volatility but continued to show signs of stabilisation amid shifting correlations and positioning dynamics.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image140}
                      alt="BTC digging in?"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image140)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image136}
                      alt="bitcoin eulogy premature"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image136)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Energy markets remained sensitive to geopolitical developments and supply considerations, with price action reflecting fluctuating risk premiums.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image131}
                        alt="oil production declines!"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image131)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The week starts with a US holiday and China’s Lunar New Year, keeping volumes lighter, before attention turns to FOMC minutes, housing and durable goods, Q4 GDP, and Friday’s PCE,
                alongside global CPI updates, the RBNZ decision, trade data, and PMIs.
              </p>
              <p className="highlightedText">Monday, February 16</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> US: </span>Washington’s Birthday holiday
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Global:</span> China Lunar New Year
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Japan:</span> Q4 GDP (QoQ, YoY, components)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> CPI (headline, core measures)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Europe:</span> Industrial production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Rightmove house prices
                  </p>
                </li>
                <li className="themesPointer">
                  <p>ECB Eurogroup meetings / Fed & ECB speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, February 17</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Employment data, unemployment rate, earnings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany / Eurozone:</span> CPI and ZEW sentiment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US:</span> Empire manufacturing index, NAHB housing index
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> CPI details and wholesale sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Trade balance, exports, imports
                  </p>
                </li>
                <li className="themesPointer">
                  <p>RBA minutes / Fed speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, February 18</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">RBNZ: </span> Rate decision and press conference
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> CPI and inflation measures
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Europe:</span> French CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Durable goods orders
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US: </span>Housing starts and building permits
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US: </span>Industrial production and capacity utilisation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span>FOMC minutes
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, February 19</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Initial jobless claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US: </span> Trade balance and goods trade
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Philadelphia Fed manufacturing index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Wholesale inventories and pending home sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan: </span> National CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>ECB bulletin / Fed speakers</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> 30-Year TIPS auction
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, February 20</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US: </span> Core PCE and PCE inflation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> GDP (Q4 advance) and GDP price index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">US: </span>Personal income and spending
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> PMIs (manufacturing, services, composite)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US: </span> Michigan consumer sentiment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK: </span> Retail sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone / Germany / France: </span>PMIs
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Loan Prime Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>CFTC positioning across major asset classes</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image144}
                    alt="EW 160226"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image144)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image143}
                    alt="US data month ahead"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image143)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Consolidation Within a Constructive Backdrop</p>
              <p>
                Markets appear to be navigating a phase of consolidation as strong earnings momentum, easing inflation pressures, and positioning resets interact with ongoing uncertainty around
                leadership and valuation adjustments.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Earnings resilience, continued capital expenditure, and improving breadth support the underlying structure even as leadership rotates away from crowded areas and momentum
                    moderates amid multiple compressions.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Precious metals remain supported by macro uncertainty, supply considerations, and shifting inflation expectations,
                    with positioning reflecting both defensive demand and sensitivity to rates.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Volatility reflects positioning adjustments and shifting correlations, with price action suggesting a period of
                    consolidation as markets weigh risk sentiment and potential recovery dynamics.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> Moderating inflation, lower yields, expectations of policy support, and ongoing fiscal and liquidity dynamics continue to
                    frame the broader environment despite near-term volatility.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                The current phase reflects repricing rather than deterioration, with markets adjusting to shifts in leadership and sentiment. Careful monitoring of flows and macro signals remains
                essential as the next directional move develops.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image86}
                    alt="equities supported by fundamentals"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image86)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image118}
                    alt="US10Y trending down"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image118)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image123}
                    alt="commodity breakout s/t resistance?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image123)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1LEKO1LiI4qNWvH7QJ4dDxH0hSNZTXEsI2v-cPvWuWrs/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog56;
